var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0834 1.33333H9.04175L8.45842 0.75H5.54175L4.95841 1.33333H2.91675V2.5H11.0834V1.33333ZM3.50008 10.0833C3.50008 10.3928 3.623 10.6895 3.84179 10.9083C4.06058 11.1271 4.35733 11.25 4.66675 11.25H9.33342C9.64283 11.25 9.93958 11.1271 10.1584 10.9083C10.3772 10.6895 10.5001 10.3928 10.5001 10.0833V3.08333H3.50008V10.0833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.81c109e410472e3085ac14803afe8320.svg";
export { ForwardRef as ReactComponent };